export const ContractLoading = ({className}) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="47.5"
        height="47.5"
        rx="23.75"
        fill="#F5F5F7"
      />
      <rect
        x="0.25"
        y="0.25"
        width="47.5"
        height="47.5"
        rx="23.75"
        stroke="#A5A5A5"
        strokeWidth="0.5"
      />
      <g clipPath="url(#clip0_1277_2885)">
        <path
          d="M18.8771 33.1445H17.3771C17.1782 33.1445 16.9874 33.0655 16.8467 32.9249C16.7061 32.7842 16.6271 32.5934 16.6271 32.3945V29.3945"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.3771 15.1445H26.3771L31.6271 20.3945V24.8945"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6271 18.1445V15.8945C16.6271 15.6956 16.7061 15.5049 16.8467 15.3642C16.9874 15.2235 17.1782 15.1445 17.3771 15.1445H19.6271"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.3771 15.1445V20.3945H31.6271"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.6271 28.6445V32.3945C31.6271 32.5934 31.5481 32.7842 31.4074 32.9249C31.2668 33.0655 31.076 33.1445 30.8771 33.1445H30.1271"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6271 21.8945V25.6445"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.6271 33.1445H26.3771"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1277_2885">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12.1271 12.1445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
